<template>
    <!-- «Палички»: з коробки стирчать хлібні палички, одна коротка. Кожен по черзі тягне одну —
         кому дісталась коротка, той платить. Паличок стільки, скільки гравців -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="found === null">Тягне <b>{{ players[turn] }}</b> — оберіть паличку</template>
            <template v-else>Коротка паличка дісталась: <b>{{ players[found] }}</b>!</template>
        </p>
        <div class="bp-wp-sticks">
            <button v-for="(stick, i) in sticks" :key="i" type="button" class="bp-wp-stick"
                    :class="{ 'is-pulled': stick.by !== null, 'is-short': stick.short }"
                    :style="{ '--bp-len': (stick.short ? 110 : 200) + 'px' }"
                    :disabled="stick.by !== null || found !== null" :aria-label="'Паличка ' + (i + 1)" @click="pull(i)">
                <span class="bp-wp-stick__body"></span>
            </button>
            <div class="bp-wp-sticks__box" aria-hidden="true"><img :src="logo" alt=""></div>
        </div>
        <ol class="bp-wp-board">
            <li v-for="(name, i) in players" :key="i" :class="{ 'is-now': found === null && i == turn, 'is-lose': found === i }">
                <span class="bp-wp-board__name">{{ name }}</span>
                <span class="bp-wp-board__val">{{ result(i) }}</span>
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    name: 'GameSticks',
    props: {
        players: { type: Array, required: true }
    },
    data() {
        const short = Math.floor(Math.random() * this.players.length);
        return {
            sticks: this.players.map((_, i) => ({ short: i === short, by: null })),
            turn: 0,
            found: null,
            logo: require('@/assets/logo_site_white.webp')
        }
    },
    methods: {
        result(i) {
            const stick = this.sticks.find(item => item.by === i);
            return stick ? (stick.short ? 'коротка!' : 'довга') : '—';
        },
        pull(i) {
            const stick = this.sticks[i];
            if (stick.by !== null || this.found !== null) return;
            stick.by = this.turn;
            if (stick.short) {
                this.found = this.turn;
                const n = this.turn + 1;
                setTimeout(() => this.$emit('done', { loser: this.found, note: 'Коротка паличка, ' + n + '-а спроба' }), 1500);
                return;
            }
            this.turn++;
        }
    }
}
</script>
